import { Breadcrumbs } from "components/breadcrumbs";
import { useOne, useParse } from "@refinedev/core";
import { FullScreenLoading } from "components/fullScreenLoading";
import { ISupportQADetail } from "interfaces";
import { EditSupportQAForm } from "./components";

export const EditSupportQA: React.FC = () => {
  const parse = useParse();
  const { params } = parse();
  const {
    data,
    isFetching,
    isPreviousData,
    isLoading,
  } = useOne<ISupportQADetail>({
    resource: "cs/support-center/qas",
    id: params?.id,
    meta: {
      resource: "data",
    },
    queryOptions: {
      enabled: !!params?.id,
    } as any,
  });

  const supportQADetailData = data?.data ?? null;

  if (isLoading) {
    return <FullScreenLoading />;
  }

  return (
    <div className="wrapper">
      <Breadcrumbs customPageLabel="Edit Support Center Q&A" />
      {supportQADetailData ? (
        <EditSupportQAForm
          defaultData={supportQADetailData}
          id={params?.id}
        />
      ) : (
        <></>
      )}
      {isFetching && isPreviousData ? <FullScreenLoading /> : <></>}
    </div>
  );
};
